import React from 'react';
import { Loader2 } from 'lucide-react';

/**
 * Outward-facing progress feedback: a thin top loading bar + a centered status pill.
 * - Determinate when `progress` (0-100) is provided (e.g. file uploads).
 * - Indeterminate (bar creeps, pill pulses) when `progress` is null (processing).
 */
export const ActionProgress = ({ active, progress, label }) => {
  if (!active) return null;
  const pct = progress == null ? null : Math.min(100, Math.max(5, Math.round(progress)));
  return (
    <div data-testid="action-progress" aria-live="polite">
      <div className="fixed top-0 left-0 right-0 z-[200] h-1 bg-[#16A34A]/15">
        <div
          className={`h-full bg-[#16A34A] ${pct == null ? 'animate-pulse w-[85%]' : 'transition-[width] duration-200 ease-out'}`}
          style={pct == null ? undefined : { width: `${pct}%` }}
        />
      </div>
      <div className="fixed top-3 left-1/2 -translate-x-1/2 z-[200] flex items-center gap-2 rounded-full bg-slate-900 text-white text-sm font-bold px-4 py-2.5 shadow-xl">
        <Loader2 className="h-4 w-4 animate-spin text-[#4ade80]" />
        <span data-testid="action-progress-label">{label}{pct != null ? ` · ${pct}%` : ''}</span>
      </div>
    </div>
  );
};

export default ActionProgress;
